import React from 'react'
import '../../Styles/F_section.css'
import nftcity from '../../Assets/Future_city-pana.png'
export default function OurProjects() {
  return (
    <div className='service'>
      <div className='serviceContainer'>
        <div className='S_Wrapper'>
          <div className='P_title'>OUR PROJECTS</div>
          <div className="future_nft">
            
            <div className="nft_services">
               <div className="circle">

               </div>
               <div className="nft_F_title">
               NFTOWN
               </div>
            </div>
            
            <div className="nft_services">
               <div className="circle">

               </div>
               <div className="nft_F_title">
               PIX EAT
               </div>
            </div>
            
           
            <div className="nft_services">
               <div className="circle">

               </div>
               <div className="nft_F_title">
               <span className='S_hide'> SUPIX </span>STORE
               </div>
    
            </div>
          </div>
        </div>
        <div className='nftcity_img_container'>  
        <img src={nftcity} alt="" className='nftcity_img'/>
        </div>
      </div>
   
      </div>
  )
}


